<!-- 集群对讲 -->
<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">群组编号</div>
        <el-input
          placeholder="请输入群组编号"
          size="medium"
          v-model="queryInfo.speakgCode"
          @change="getSpeakGroup()"
          clearable
        >
        </el-input>
      </div>
      <div class="userNameSearch">
        <div class="searchTxt">群组名称：</div>
        <el-input
          placeholder="请输入群组名称"
          size="medium"
          v-model="queryInfo.sepakgName"
          @change="getSpeakGroup()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位人员设备卡片区域 -->
      <div class="leftBox">
        <!-- 单位人员设备树 -->

        <el-tree
          class="treeBox"
          :data="ArchInfo"
          :props="defaultTreesProps"
          show-checkbox
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          node-key="name"
          ref="navTree"
          @check-change="getCheckedDevicesNodes"
        >
          <!-- :render-content="renderContent"  -->
          <span slot-scope="{ node, data }">
            <div class="bigTree">
              <div class="leftTree">
                <div>
                  <!-- 单位图标 -->
                  <img
                    v-show="data.type == 1"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/dw.svg"
                  />
                  <!-- 人员图标 -->
                  <img
                    v-show="data.type == 2"
                    style="width: 24px; height: 24px; margin-right: 2px"
                    src="../../../assets/img/tree/ry.svg"
                  />
                  <!-- 执法仪不在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == false"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj.svg')
                        : require('../../../assets/img/tree/zngb.svg')
                    "
                  />
                  <!-- 执法仪在线图标 -->
                  <img
                    v-show="data.type == 3 && data.status.online == true"
                    style="width: 24px; height: 24px"
                    :src="
                      data.devideType == 1
                        ? require('../../../assets/img/tree/zfy_online.svg')
                        : data.devideType == 2
                        ? require('../../../assets/img/tree/bkq_online.svg')
                        : data.devideType == 3
                        ? require('../../../assets/img/tree/aqm_online.svg')
                        : data.devideType == 4
                        ? require('../../../assets/img/tree/wrj_online.svg')
                        : data.devideType == 5
                        ? require('../../../assets/img/tree/jksxj_online.svg')
                        : require('../../../assets/img/tree/zngb_online.svg')
                    "
                  />
                </div>

                <!-- 设备名称 -->
                <el-tooltip
                  v-show="data.type == 3"
                  class="item"
                  effect="dark"
                  :content="node.label"
                  placement="top"
                >
                  <div ref="nodeLabel">
                    <div v-if="node.label.length > 8">
                      {{
                        node.label.replace(
                          /(\d{3})\d*([0-9a-zA-Z]{3})/,
                          "$1***$2"
                        )
                      }}
                    </div>
                    <div v-else>
                      {{ node.label }}
                    </div>
                  </div>
                </el-tooltip>

                <!--  -->
                <!-- 单位和人员名称 -->
                <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <!-- 右边单位人员设备卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加对讲群组按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddSpeakGroupDialogVisible = true"
          >
            新增对讲群组
          </el-button>
          <!-- 绑定对讲设备按钮 -->
          <el-button
            icon="el-icon-share"
            type="primary"
            size="small"
            class="add-btn"
            @click="sendSpeakGroupToDevices"
            v-if="sendTaskBtn"
          >
            绑定对讲设备
          </el-button>
          <!-- 对讲群组信息表格区域 -->
          <el-table
            :data="speakList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            :header-cell-class-name="headerCellStyle"
            @select="selectChange"
            @selection-change="handleSelectionChange"
            ref="SpeakGroupTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="speakgCode" label="群组编号">
            </el-table-column>
            <el-table-column prop="sepakgName" label="群组名称">
            </el-table-column>
            <el-table-column prop="speakgCreatetime" label="创建时间">
            </el-table-column>

            <el-table-column label="对讲群组设备">
              <template v-slot="slotSpeakgId">
                <el-button
                  type="primary"
                  size="small"
                  @click="getspeakGroupDevice(slotSpeakgId.row.speakgId)"
                  >查看对讲群组设备</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="170">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  content="开启对讲"
                  placement="bottom-start"
                  effect="dark"
                  v-if="!slot.row.isCalling"
                >
                  <el-button
                    type="primary"
                    size="small"
                    circle
                    icon="el-icon-microphone"
                    @click="startCall(slot.row.speakgId, slot.$index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="关闭对讲"
                  placement="bottom-start"
                  effect="dark"
                  v-if="slot.row.isCalling"
                >
                  <el-button
                    type="success"
                    size="small"
                    circle
                    icon="el-icon-turn-off-microphone"
                    @click="stopCall(slot.row.speakgId, slot.$index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="修改"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="updateSpeakByspeakgId(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteTaskByplId(slot.row.speakgId)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加对讲群组信息对话框 -->
    <el-dialog
      title="新增对讲群组"
      :visible.sync="AddSpeakGroupDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddSpeakGroupDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addSpeakGroupFormRef"
        :rules="AddSpeakGroupRules"
        :model="SpeakGroupInfo"
        label-width="80px"
      >
        <el-form-item prop="speakgCode" label="群组编号">
          <el-input
            placeholder="请输入群组编号"
            v-model="SpeakGroupInfo.speakgCode"
            clearable
            type="number"
            min="1"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="sepakgName" label="群组名称">
          <el-input
            placeholder="请输入群组名称"
            v-model="SpeakGroupInfo.sepakgName"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddSpeakGroupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddSpeakGroup()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改对讲群组信息对话框 -->
    <el-dialog
      title="修改对讲群组信息"
      :visible.sync="UpdateSpeakGroupDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateSpeakGroupDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updateSpeakGroupFormRef"
        :rules="AddSpeakGroupRules"
        :model="UpdateSpeakGroupInfo"
        label-width="80px"
      >
        <el-form-item prop="speakgCode" label="群组编号">
          <el-input
            placeholder="请输入群组编号"
            v-model="UpdateSpeakGroupInfo.speakgCode"
            clearable
            type="number"
            min="1"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="sepakgName" label="群组名称">
          <el-input
            placeholder="请输入群组名称"
            v-model="UpdateSpeakGroupInfo.sepakgName"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateSpeakGroupDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="UpdateSpeakGroup()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看对讲群组信息对话框 -->
    <el-dialog
      title="对讲群组设备"
      :visible.sync="sendDevicesDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearsendDevicesDialogVisible()"
    >
      <el-table
        :data="sendDevicesList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        :default-sort="{ prop: 'devCreatetime', order: 'descending' }"
      >
        <el-table-column prop="devEmpName" label="使用人员"> </el-table-column>
        <el-table-column prop="devNo" label="设备编号"> </el-table-column>
        <el-table-column prop="devCreatetime" sortable label="下发时间">
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="UnissueSlot">
            <el-button
              type="warning"
              size="small"
              @click="Unissue(UnissueSlot.row.devId)"
              >解除对讲</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>


<script>
var validateNumOrLetter = (rule, value, callback) => {
  // 只允许输入数字
  const reg = /^[0-9]*$/;
  if (value === "") {
    callback(new Error("请输入群组编号"));
  } else if (!reg.test(value)) {
    callback(new Error("只能输入数字"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      //对讲列表信息
      speakList: [],
      // 对讲群组列表查询信息
      queryInfo: {
        // 群组ID
        speakgCode: "",
        // 群组名称
        sepakgName: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      //  单位总数量
      total: 0,
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 控制增加对讲群组对话框的显示和隐藏
      AddSpeakGroupDialogVisible: false,
      // 控制发送对讲群组绑定设备按钮显示与隐藏
      sendTaskBtn: false,
      // 对讲群组绑定设备参数
      sendSpeakGroupToDevicesInfo: {
        devIds: [], //群组id
        speakId: "", //群组id
      },
      // 对讲群组实体
      SpeakGroupInfo: {
        //群组编号
        speakgCode: "",
        // 群组名称
        sepakgName: "",
      },

      // 查看下发设备对话框
      sendDevicesDialog: false,
      // 群组下发设备
      sendDevicesList: [],
      //解除群组对讲下发设备的群组ID
      unissueSpeakgId: "",
      //增加对讲群组规则校验
      AddSpeakGroupRules: {
        speakgCode: [
          {
            required: true,
            trigger: "blur",
            validator: validateNumOrLetter,
          },
        ],
        sepakgName: [
          {
            required: true,
            message: "请输入群组名称",
            trigger: "blur",
          },
        ],
        taskContent: [
          {
            required: true,
            message: "请输入对讲内容",
            trigger: "blur",
          },
        ],
      },
      //  控制修改对讲群组显示与隐藏
      UpdateSpeakGroupDialogVisible: false,

      // 修改对讲群组实体
      UpdateSpeakGroupInfo: {
        //群组编号
        speakgCode: "",
        // 群组名称
        sepakgName: "",
        speakgId: "",
      },

      // ===============对讲相关参数=========
      ws: null,
      mediaStack: null,
      audioCtx: null,
      scriptNode: null,
      source: null,
      play: true,
      spacePressed: false, // 添加一个是否开启了对讲标记
      call: {
        speakType: "group", //group标识群组  device标识单个设备
        id: "0", //group的时候标识群组号device的时候标识设备编号  测试：832136180001550
      },
      // ===============对讲相关参数=========
    };
  },
  created() {
    // 获取对讲列表信息
    this.getSpeakGroup();
    // 获取单位人员设备树
    this.getDepPersonDevTree();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    // 在离开当前路由页面之前关闭WebSocket连接
    this.closeWebSocket();
    next();
  },
  methods: {
    // 查询对讲列表信息
    async getSpeakGroup() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/speakGroup/search`,
        {
          params: this.queryInfo,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.speakList = res.data.rows;
        this.speakList = this.speakList.map((obj) => ({
          ...obj,
          isCalling: false,
        }));
        // 对讲总数量
        this.total = res.data.total;
      }
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getSpeakGroup();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getSpeakGroup();
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes() {
      var devices = this.$refs.navTree.getCheckedNodes();
      var devIds = [];
      for (let i = 0; i < devices.length; i++) {
        const element = devices[i];
        if (element.type == 3) {
          devIds.push(element.id);
        }
      }
      this.sendSpeakGroupToDevicesInfo.devIds = devIds;
    },

    // 获取table选中的车牌信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendTaskBtn = true;
        this.sendSpeakGroupToDevicesInfo.speakId = val[0].speakgId;
      } else {
        this.sendTaskBtn = false;
      }
      // var speakgId = [];
      // for (let i = 0; i < val.length; i++) {
      //   speakgId.push(val[i].speakgId);
      // }
    },
    // 将table表格设置成单选
    headerCellStyle({ column, columnIndex }) {
      if (columnIndex === 0) {
        return "hiddenCheck";
      }
    },

    // 改为单选，即通过Array.shift()方法删除第一条数据并返回新数组，这样就可以把select 事件中的以获取的数组给删掉，同时通过toggleRowSelection方法将删掉的这一行选择状态设置为未选择。
    selectChange(selection) {
      if (selection.length > 1) {
        const del_row = selection.shift();
        this.$refs.SpeakGroupTable.toggleRowSelection(del_row, false);
      }
    },
    // 对讲群组绑定设备下发
    async sendSpeakGroupToDevices() {
      if (this.sendSpeakGroupToDevicesInfo.devIds.length == 0) {
        return this.$message.warning("请选择对讲群组的设备!");
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/speakGroup/bind`,
        this.sendSpeakGroupToDevicesInfo
      );
      if (res.status != 0) {
        // 设备已添加的群组的返回加提示判断（后端返回状态是21）
        if (res.status === 21) {
          let groupName = "";
          for (let i = 0; i < res.data.length; i++) {
            groupName =
              groupName +
              res.data[i].speakgName +
              ":" +
              res.data[i].devNo +
              ";";
          }
          return this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              res.msg + "<br>" + "已绑定的群组设备：" + "(" + groupName + ")",
          });
        }
        return this.$message.error(res.msg);
      }
      // 清空树的选中
      this.$refs.navTree.setCheckedNodes([]);
      // 清空表格选中值
      this.$refs.SpeakGroupTable.clearSelection();
      this.$message.success("对讲群组绑定设备成功");
    },

    // 根据对讲群组查看对应下发的设备
    async getspeakGroupDevice(speakgId) {
      this.unissueSpeakgId = speakgId;
      const { data: res } = await this.$axios.get(
        `${this.$api}/speakGroup/getGroupByDevice`,
        {
          params: { speakgId: speakgId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesDialog = true;
      if (res.data.rows !== null && res.data.rows !== "") {
        this.sendDevicesList = res.data.rows;
      }
    },

    // 解除设备对讲
    async Unissue(devId) {
      const confirmVal = await this.$confirm(
        "此操作将会解除此设备的对讲, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/speakGroup/unissue`,
        {
          params: { devId: devId, speakgId: this.unissueSpeakgId },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.sendDevicesList = [];
      this.$message.success("已解除此设备的对讲!");
      this.getspeakGroupDevice(this.unissueSpeakgId);
    },
    // 关闭对讲查看对应下发的设备对话框
    clearsendDevicesDialogVisible() {
      this.sendDevicesList = [];
    },
    // 添加对讲群组
    AddSpeakGroup() {
      this.$refs.addSpeakGroupFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/speakGroup/add`,
          this.SpeakGroupInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("对讲群组添加成功");
        this.AddSpeakGroupDialogVisible = false;
        this.getSpeakGroup();
      });
    },
    //关闭增加对讲信息
    clearAddSpeakGroupDialogVisible() {
      this.$refs.addSpeakGroupFormRef.resetFields();
    },
    // 修改对讲群组信息
    updateSpeakByspeakgId(value) {
      this.UpdateSpeakGroupDialogVisible = true;
      this.UpdateSpeakGroupInfo.sepakgName = value.sepakgName;
      this.UpdateSpeakGroupInfo.speakgCode = value.speakgCode;
      this.UpdateSpeakGroupInfo.speakgId = value.speakgId;
    },
    //  修改对讲信息
    async UpdateSpeakGroup() {
      const { data: res } = await this.$axios.put(
        `${this.$api}/speakGroup/edit/${this.UpdateSpeakGroupInfo.speakgId}`,
        {
          sepakgName: this.UpdateSpeakGroupInfo.sepakgName,
          speakgCode: this.UpdateSpeakGroupInfo.speakgCode,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("修改对讲群组信息成功");
      this.getSpeakGroup();
      this.UpdateSpeakGroupDialogVisible = false;
    },

    //关闭修对讲群组信息对话框
    clearUpdateSpeakGroupDialogVisible() {
      this.$refs.updateSpeakGroupFormRef.resetFields();
    },
    // 删除对讲群组
    async deleteTaskByplId(speakgId) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该对讲群组, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/speakGroup/delete/` + speakgId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("对讲群组删除成功");
      this.getSpeakGroup();
    },
    //================ 对讲相关============
    // 建立WebSocket连接
    createWebSocket() {
      const httpType = location.protocol === "https:" ? "wss://" : "ws://";

      // console.log(location);
      // console.log(httpType+location.hostname+":"+window.g.Talk_port);
      // this.ws = new WebSocket(
      //   httpType + `${location.host}/websocket/audio/web1`
      // )
      // 测试环境
      // this.ws = new WebSocket(this.$cpi);
      // this.ws = new WebSocket(httpType+location.hostname+":"+window.g.Talk_port);
      this.ws = new WebSocket(httpType + window.g.Talk_URL);
      this.ws.onopen = () => {
        console.log("socket 已连接");
      };
    },
    // 关闭WebSocket连接
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        // this.ws = null;
      }
    },
    initWs1() {
      // 连接 websocket,边端发送音频流
      // const httpType = location.protocol === "https:" ? "wss://" : "ws://";
      // // this.ws = new WebSocket(
      // //   httpType + `${location.host}/websocket/audio/web1`
      // // )
      // this.ws = new WebSocket("ws://192.168.0.97:5054");
      // // this.ws = new WebSocket("ws://192.168.0.97:8051/speak/token");
      // this.ws.onopen = () => {
      //   console.log("socket 已连接");
      // };
      this.ws.send(JSON.stringify(this.call)); //发送对讲类型
      this.ws.binaryType = "arraybuffer";
      this.ws.onmessage = ({ data }) => {
        // 将接收的数据转换成与传输过来的数据相同的Float32Array
        const buffer = new Float64Array(data);

        // =======将Int16Array的数据转换成Float32Array======
        // let output = new Float32Array(2048);
        // for (var i = 0; i < 2048; i++) {
        //   let int = buffer[i];
        //   let float = int >= 0x8000 ? -(0x10000 - int) / 0x8000 : int / 0x7fff;
        //   output[i] = float;
        // }
        // this.buffer = output;
        // =======将nt16Array的数据转换成Float32Array======

        // console.log("收到源数据:", data);
        // console.log("收到:", buffer);

        // 创建一个空白的AudioBuffer对象，这里的4096跟发送方保持一致，48000是采样率
        const myArrayBuffer = this.audioCtx.createBuffer(1, 512, 8000);
        // 也是由于只创建了一个音轨，可以直接取到0
        const nowBuffering = myArrayBuffer.getChannelData(0);
        // 通过循环，将接收过来的数据赋值给简单音频对象
        for (let i = 0; i < 512; i++) {
          nowBuffering[i] = buffer[i];
        }
        // 使用AudioBufferSourceNode播放音频
        const source = this.audioCtx.createBufferSource();
        source.buffer = myArrayBuffer;

        const gainNode = this.audioCtx.createGain();
        source.connect(gainNode);
        gainNode.connect(this.audioCtx.destination);
        var muteValue = 1;
        if (!this.play) {
          // 是否静音
          muteValue = 0;
        }
        gainNode.gain.setValueAtTime(muteValue, this.audioCtx.currentTime);
        source.start();
      };
      this.ws.onerror = (e) => {
        console.log("error", e);
      };
      this.ws.onclose = () => {
        console.log("socket closed");
      };
    },
    // 开始对讲
    startCall(speakgId, index) {
      // 重置对讲按钮状态
      for (let j = 0; j < this.speakList.length; j++) {
        this.speakList[j].isCalling = false;
      }
      // 在创建组件时建立WebSocket连接
      this.createWebSocket();
      setTimeout(() => {
        // 将前面开启对讲为停止对讲的按钮改为未开启状态
        this.speakList[index].isCalling = true;
        // 对讲群组ID
        this.call.id = speakgId;
        this.play = true;
        // this.audioCtx = new AudioContext({ sampleRate: 8000 });
        // 获取浏览器
        const agent = navigator.userAgent;
        //  如果是火狐就默认系统采样率，其他的默认8000采样率
        if (agent.indexOf("Firefox") > 0) {
          this.audioCtx = new (AudioContext || webkitAudioContext)({});
        } else {
          this.audioCtx = new (AudioContext || webkitAudioContext)({
            sampleRate: 8000,
          });
        }
        this.initWs1();
        // 该变量存储当前MediaStreamAudioSourceNode的引用
        // 可以通过它关闭麦克风停止音频传输

        // 判断浏览器是否支持音频输入
        navigator.getUserMedia =
          navigator.getUserMedia || navigator.webkitGetUserMedia;
        if (!navigator.getUserMedia) {
          this.$message.warning("浏览器不支持音频输入,请进行相关设置");
        }
        // 告诉后端采样率多少
        this.ws.send(JSON.stringify({ sampleRate: this.audioCtx.sampleRate }));
        // 创建一个ScriptProcessorNode 用于接收当前麦克风的音频
        this.scriptNode = this.audioCtx.createScriptProcessor(1024, 1, 1);
        navigator.mediaDevices
          .getUserMedia({ audio: true, video: false })
          .then((stream) => {
            this.mediaStack = stream;
            this.source = this.audioCtx.createMediaStreamSource(stream);

            this.source.connect(this.scriptNode);
            this.scriptNode.connect(this.audioCtx.destination);
          })
          .catch(function (err) {
            /* 处理error */
            console.log("err", err);
          });
        // 当麦克风有声音输入时，会调用此事件
        // 实际上麦克风始终处于打开状态时，即使不说话，此事件也在一直调用
        this.scriptNode.onaudioprocess = (audioProcessingEvent) => {
          const inputBuffer = audioProcessingEvent.inputBuffer;
          // 由于只创建了一个音轨，这里只取第一个频道的数据
          const inputData = inputBuffer.getChannelData(0);
          // 通过socket传输数据，实际上传输的是Float32Array
          // let inputData1 = new Float64Array(1024);
          // for (let index = 0; index < 1024; index++) {
          //   inputData1[index] = inputData[index];
          // }
          if (this.ws.readyState === 1) {
            this.ws.send(new Float32Array(inputData));
            // console.log(new Float32Array(inputData));
            // this.compressPCM(inputData);

            // // 创建新的 AudioBuffer 对象
            // const buffer = this.audioCtx.createBuffer(
            //   1,
            //   inputData.length,
            //   this.audioCtx.sampleRate
            // );
            // // 将 inputData 数据存储在 buffer 中的第一个音轨中
            // buffer.getChannelData(0).set(inputData);

            // // 创建新的 AudioBufferSourceNode
            // const sourceNode = this.audioCtx.createBufferSource();
            // sourceNode.buffer = buffer;

            // // 连接 AudioBufferSourceNode 到 AudioContext 目标节点
            // sourceNode.connect(this.audioCtx.destination);
            // // 播放音频
            // if (this.play) {
            //   sourceNode.start();
            // }
          }
        };
      }, 500);
    },
    // 关闭麦克风
    stopCall(speakgId, index) {
      // 对讲群组ID
      this.call.id = speakgId;
      this.play = false;
      // 切换对讲按钮状态
      this.speakList[index].isCalling = false;
      if (this.mediaStack) {
        this.mediaStack.getTracks().forEach((track) => {
          track.stop();
        });
        this.scriptNode.disconnect();
      }

      // 关闭websockrt
      this.closeWebSocket();
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 260px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}
// 表格对讲内容样式修改
.taskContent {
  -webkit-line-clamp: 1; /* 显示的行数 */
  display: -webkit-box; /*必须结合的属性,将对象作为弹性伸缩盒子模型显示*/
  -webkit-box-orient: vertical; /*必须结合的属性,设置或检索伸缩盒对象的子元素的排列方式*/
  overflow: hidden; /*文本会被修剪，并且剩余的部分不可见*/
  text-overflow: ellipsis; /*显示省略号来代表被修剪的文本*/
}

// 重新设置其样式将该”全选框“隐藏掉。
/deep/.hiddenCheck {
  visibility: hidden;
}
/deep/.el-table__header-wrapper {
  background: #0395d9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CombinedAction/clusterIntercom.vue